
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./thena-sdk.cjs.production.min.js')
} else {
  module.exports = require('./thena-sdk.cjs.development.js')
}
